import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { PriorityInputIcon } from "./priority/PriorityInputIcon";

type Props = {
  type: "dropdown";
} & FormItemProps<SaveTicketValues>;

export const PriorityInput = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("priority");

  if (config && (config.hidden || config.priority?.length === 0)) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.priority.label");

  return (
    <>
      <Form.Item<SaveTicketValues>
        name="priority"
        label={label}
        help={config?.help}
        rules={[
          {
            required: config?.required,
            message: t("maintenance:ticket.create.priority.error.empty"),
          },
        ]}
        {...props}
      >
        {props.type === "dropdown" ? <PriorityInputIcon /> : null}
      </Form.Item>
    </>
  );
});
